"use client";

import React from "react";
import HeaderContext from "./context";

function useHeader() {
  const context = React.useContext(HeaderContext);

  if (!context) {
    throw new Error("useHeader must be used inside of HeaderProvider");
  }

  return context;
}

export default useHeader;
